/* Keep shoppers off the native /cart page when Kaching handles add-to-cart.
   PageFly and other apps post to /cart/add without product-form.js. */
(function () {
  var ADD_WINDOW_MS = 4000;
  var lastAddAt = 0;
  var addRequestCount = 0;

  function kachingDown() {
    return window.__kachingCartFailedModuleLoad === true || window.__kachingCartDisabled === true;
  }

  function markAdd() {
    lastAddAt = Date.now();
  }

  function inAddWindow() {
    return lastAddAt > 0 && Date.now() - lastAddAt < ADD_WINDOW_MS;
  }

  function cartPath() {
    var path = (window.routes && window.routes.cart_url) || '/cart';
    try {
      return new URL(path, window.location.origin).pathname.replace(/\/+$/, '') || '/cart';
    } catch (e) {
      return '/cart';
    }
  }

  function isCartPageUrl(url) {
    if (!url || url === '#') return false;
    try {
      var parsed = new URL(String(url), window.location.origin);
      if (parsed.origin !== window.location.origin) return false;
      var path = parsed.pathname.replace(/\/+$/, '') || '/';
      return path === cartPath();
    } catch (e) {
      return false;
    }
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    return /\/cart\/add(\.js)?(\?|#|$)/.test(String(url));
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    return isCartAddUrl(form.getAttribute('action')) || isCartAddUrl(form.action);
  }

  function shouldBlockCartNavigation(url) {
    if (kachingDown()) return false;
    if (!inAddWindow()) return false;
    return isCartPageUrl(url);
  }

  function noteCartAdd(url) {
    if (!isCartAddUrl(url)) return false;
    addRequestCount += 1;
    markAdd();
    return true;
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var isAdd = noteCartAdd(url);
      var request = originalFetch.apply(this, arguments);
      if (!isAdd) return request;
      return request.then(function (response) {
        if (response && response.ok) markAdd();
        return response;
      });
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__kachingCartAdd = isCartAddUrl(url);
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__kachingCartAdd) {
      noteCartAdd('/cart/add.js');
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 400) markAdd();
      });
    }
    return originalSend.apply(this, arguments);
  };

  document.addEventListener(
    'submit',
    function (event) {
      if (kachingDown()) return;
      var form = event.target;
      if (!isCartAddForm(form)) return;

      event.preventDefault();
      markAdd();

      var countAtSubmit = addRequestCount;
      window.setTimeout(function () {
        if (kachingDown()) return;
        if (addRequestCount > countAtSubmit) return;

        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        var body = new FormData(form);
        if (!body.get('id') && !body.get('items')) return;

        fetch(addUrl, {
          method: 'POST',
          body: body,
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        }).catch(function () {});
      }, 60);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!inAddWindow() || kachingDown()) return;
      var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!link || link.id === 'cart-icon-bubble') return;
      if (!isCartPageUrl(link.href)) return;
      event.preventDefault();
    },
    true
  );

  try {
    var assign = window.location.assign.bind(window.location);
    var replace = window.location.replace.bind(window.location);
    window.location.assign = function (url) {
      if (shouldBlockCartNavigation(url)) return;
      return assign(url);
    };
    window.location.replace = function (url) {
      if (shouldBlockCartNavigation(url)) return;
      return replace(url);
    };
  } catch (e) {}

  var originalPushState = history.pushState;
  var originalReplaceState = history.replaceState;
  history.pushState = function (state, title, url) {
    if (url && shouldBlockCartNavigation(url)) return;
    return originalPushState.apply(history, arguments);
  };
  history.replaceState = function (state, title, url) {
    if (url && shouldBlockCartNavigation(url)) return;
    return originalReplaceState.apply(history, arguments);
  };

  if (window.navigation && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener('navigate', function (event) {
      var url = event.destination && event.destination.url;
      if (!shouldBlockCartNavigation(url)) return;
      if (event.cancelable) event.preventDefault();
    });
  }
})();
